"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4836],{

/***/ 64836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Maps; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-leaflet/esm/MapContainer.js
var MapContainer = __webpack_require__(56628);
// EXTERNAL MODULE: ../../node_modules/react-leaflet/esm/TileLayer.js + 1 modules
var TileLayer = __webpack_require__(1172);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63964);
// EXTERNAL MODULE: ../../node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(48090);
// EXTERNAL MODULE: ../core/src/config/theme.js
var theme = __webpack_require__(46487);
var theme_default = /*#__PURE__*/__webpack_require__.n(theme);
// EXTERNAL MODULE: ../../node_modules/@react-leaflet/core/esm/generic.js + 8 modules
var generic = __webpack_require__(78794);
// EXTERNAL MODULE: ../../node_modules/leaflet/dist/leaflet-src.js
var leaflet_src = __webpack_require__(15623);
// EXTERNAL MODULE: ../../node_modules/leaflet.fullscreen/Control.FullScreen.js
var Control_FullScreen = __webpack_require__(39443);
;// CONCATENATED MODULE: ../core/src/components/Maps/Controls/FullScreenControl.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FullScreenControl = (0,generic/* createControlComponent */.vm)(function(props) {
    return leaflet_src.control.fullscreen(_objectSpread({
        position: 'topright',
        forceSeparateButton: true
    }, props));
});

;// CONCATENATED MODULE: ../assets/icons/plus.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 8c0 .27.098.502.294.697a.954.954 0 0 0 .698.294h6.023v6.018c0 .261.097.492.293.691.196.2.429.3.698.3.27 0 .5-.1.692-.3.192-.2.287-.43.287-.69V8.99h6.036a.94.94 0 0 0 .685-.293A.952.952 0 0 0 16 8a.952.952 0 0 0-.294-.697.94.94 0 0 0-.685-.294H8.985V.991A.969.969 0 0 0 8.698.3a.925.925 0 0 0-.692-.3c-.27 0-.502.1-.698.3a.959.959 0 0 0-.293.69v6.02H.992a.954.954 0 0 0-.698.293A.952.952 0 0 0 0 8Z",
    fill: "#014152"
  })));
};

/* harmony default export */ var plus = (SvgPlus);
;// CONCATENATED MODULE: ../assets/icons/minus.svg
var minus_path;

function minus_extends() { minus_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return minus_extends.apply(this, arguments); }



var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/react.createElement("svg", minus_extends({
    viewBox: "0 0 16 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), minus_path || (minus_path = /*#__PURE__*/react.createElement("path", {
    d: "M.992 2H15.02c.26 0 .49-.099.685-.296A.965.965 0 0 0 16 1a.965.965 0 0 0-.294-.704.936.936 0 0 0-.685-.296H.99a.95.95 0 0 0-.697.296A.965.965 0 0 0 0 1c0 .272.098.506.294.704A.95.95 0 0 0 .992 2Z",
    fill: "#014152"
  })));
};

/* harmony default export */ var minus = (SvgMinus);
;// CONCATENATED MODULE: ../core/src/components/Maps/Controls/ZoomControl.tsx








function ZoomControl_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ZoomControl_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ZoomControl_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 24px;\n  height: 1px;\n  background-color: ",
        ";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Separator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65d88162-0"
})(_templateObject(), (theme_default()).colors.gray[400]);
var ZoomControl = (0,generic/* createControlComponent */.vm)(function(props) {
    var instance = leaflet_src.Control.Zoom.extend({
        onAdd: function onAdd(map) {
            var element = leaflet_src.Control.Zoom.prototype.onAdd.call(this, map);
            element.insertAdjacentHTML('beforeend', (0,server_browser.renderToStaticMarkup)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {})));
            return element;
        }
    });
    return new instance(ZoomControl_objectSpread({
        position: 'topright',
        zoomInText: (0,server_browser.renderToStaticMarkup)(/*#__PURE__*/ (0,jsx_runtime.jsx)(plus, {
            width: 16,
            height: 16
        })),
        zoomOutText: (0,server_browser.renderToStaticMarkup)(/*#__PURE__*/ (0,jsx_runtime.jsx)(minus, {
            width: 16,
            height: 2
        }))
    }, props));
});

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/react-leaflet/esm/hooks.js
var hooks = __webpack_require__(89507);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../core/src/components/Card.tsx
var Card = __webpack_require__(28658);
;// CONCATENATED MODULE: ../assets/icons/map.svg
var map_path;

function map_extends() { map_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return map_extends.apply(this, arguments); }



var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/react.createElement("svg", map_extends({
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), map_path || (map_path = /*#__PURE__*/react.createElement("path", {
    d: "M1.109 17.654c.122 0 .248-.02.377-.063.13-.042.275-.106.435-.19l4.527-2.443 4.995 2.765c.336.185.69.277 1.064.277.343 0 .651-.077.926-.23l4.721-2.674c.29-.161.503-.365.64-.61a1.72 1.72 0 0 0 .206-.854V1.476c0-.361-.097-.64-.291-.835-.195-.196-.471-.294-.83-.294-.121 0-.247.02-.377.063-.13.042-.274.106-.434.19l-4.756 2.685L7.397.242A1.71 1.71 0 0 0 6.492 0c-.35 0-.663.08-.937.242L.846 2.915c-.29.162-.503.365-.64.611A1.697 1.697 0 0 0 0 4.367v12.158c0 .361.097.64.292.835.194.196.466.294.817.294Zm4.676-4.344-3.899 2.143a.359.359 0 0 1-.125.046c-.077 0-.115-.042-.115-.126V4.793c0-.107.025-.203.075-.287a.644.644 0 0 1 .222-.22l3.522-2.039c.053-.038.106-.073.16-.104l.16-.092V13.31Zm1.657.173V2.282c.046.023.094.05.143.08.05.031.097.062.143.093l3.83 2.35v10.96a1.918 1.918 0 0 0-.206-.122 5.4 5.4 0 0 1-.206-.11l-3.704-2.05Zm5.762 2.477V4.702l3.91-2.155a.358.358 0 0 1 .125-.046c.039 0 .065.011.08.034a.165.165 0 0 1 .023.092v10.59a.596.596 0 0 1-.068.289.596.596 0 0 1-.217.219l-3.419 1.982a3.902 3.902 0 0 1-.434.253Z",
    fill: "#014152"
  })));
};

/* harmony default export */ var icons_map = (SvgMap);
;// CONCATENATED MODULE: ../assets/images/base-tile.png
/* harmony default export */ var base_tile = ({"src":"/_next/static/media/base-tile.d6782159.png","height":420,"width":672,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAABlBMVEXs4Mzd285L76FXAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAEklEQVQImWNgQAaMGAy4AEgEAABrAAXlndhhAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../assets/images/orthographic-tile.png
/* harmony default export */ var orthographic_tile = ({"src":"/_next/static/media/orthographic-tile.4e3f40db.png","height":210,"width":336,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAG1BMVEUaKikeLCsgLy1SVkl9eGQ+R0AvPDZkZFSOhm+OIXLfAAAACXBIWXMAACE4AAAhOAFFljFgAAAAJ0lEQVQImR3GwREAIAzDMDttgf0n5uAlsdYEEqq6wJ9BpPegyuk8uAkuAF44AiQqAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../assets/images/topographic-tile.png
/* harmony default export */ var topographic_tile = ({"src":"/_next/static/media/topographic-tile.7c0c8828.png","height":210,"width":336,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAG1BMVEXp5+LI1LPU2MfK17zZ4srR3cDb3NC108vh4dh5WHxGAAAACXBIWXMAACE4AAAhOAFFljFgAAAAJ0lEQVQImR3GyQ0AIAwDsJyU/SdGxS8DM8a6pp2NSAbBkcjmR3b7AAl9AHLP+jm5AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../core/src/components/Maps/Controls/TileLayerControl.tsx













function TileLayerControl_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TileLayerControl_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TileLayerControl_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function TileLayerControl_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function TileLayerControl_templateObject() {
    var data = TileLayerControl_taggedTemplateLiteral([
        "\n  absolute\n  right-[50px]\n  top-0\n"
    ]);
    TileLayerControl_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = TileLayerControl_taggedTemplateLiteral([
        "\n  flex\n  w-28\n  h-27\n  rounded-lg\n  flex-col\n  overflow-hidden\n  font-medium\n  cursor-pointer\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var controlContainer = leaflet_src.DomUtil.create('div');
var LeafletTileLayerControl = leaflet_src.Control.extend({
    onAdd: function onAdd() {
        leaflet_src.DomEvent.disableClickPropagation(controlContainer);
        return controlContainer;
    }
});
var tileURLs = {
    base: "https://api.mapbox.com/styles/v1/danieliusforos/ckwusk8l345d615nvts439he1/tiles/256/{z}/{x}/{y}@2x?access_token=".concat("pk.eyJ1IjoiZGFuaWVsaXVzZm9yb3MiLCJhIjoiY2tyMGVudXQ5MXF2ZTJ6cWFhZ2M5dTd6ZSJ9.zcnKxFp9TaZmXBOmyIvp0A"),
    orthographic: "https://api.mapbox.com/styles/v1/danieliusforos/ckraqq3xk2mkq18ou9lqae6r9/tiles/256/{z}/{x}/{y}@2x?access_token=".concat("pk.eyJ1IjoiZGFuaWVsaXVzZm9yb3MiLCJhIjoiY2tyMGVudXQ5MXF2ZTJ6cWFhZ2M5dTd6ZSJ9.zcnKxFp9TaZmXBOmyIvp0A"),
    topographic: "https://api.mapbox.com/styles/v1/danieliusforos/ckx5zungm7kd314o3pzmxpomq/tiles/256/{z}/{x}/{y}@2x?access_token=".concat("pk.eyJ1IjoiZGFuaWVsaXVzZm9yb3MiLCJhIjoiY2tyMGVudXQ5MXF2ZTJ6cWFhZ2M5dTd6ZSJ9.zcnKxFp9TaZmXBOmyIvp0A")
};
var Popup = dist_default().div(TileLayerControl_templateObject());
var TileLayerContainer = dist_default().div(_templateObject1(), function(param) {
    var $active = param.$active;
    return $active ? 'border-2 border-secondary-500' : 'border border-gray-400';
});
var BaseTileLayer = function(param) {
    var url = param.url, image = param.image, title = param.title, onClick = param.onClick, selected = param.selected;
    var handleClick = (0,react.useCallback)(function() {
        return onClick(url);
    }, [
        onClick,
        url
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(TileLayerContainer, {
        onClick: handleClick,
        $active: selected,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                src: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "px-2 py-1 text-center",
                children: title
            })
        ]
    }));
};
var TileLayerControl = function(param) {
    var _position = param.position, position = _position === void 0 ? 'topright' : _position;
    var t = (0,esm/* useTranslation */.$G)('common').t;
    var ref = (0,react.useState)(false), popupOpen = ref[0], setPopupOpen = ref[1];
    var ref1 = (0,react.useState)(tileURLs.orthographic), tileURL = ref1[0], setTileURL = ref1[1];
    var map = (0,hooks/* useMap */.Sx)();
    var closePopup = (0,react.useCallback)(function() {
        return setPopupOpen(false);
    }, []);
    var handleLayerChange = (0,react.useCallback)(function(url) {
        setTileURL(url);
        closePopup();
    }, [
        closePopup
    ]);
    var tileLayers = (0,react.useMemo)(function() {
        return [
            {
                url: tileURLs.orthographic,
                image: orthographic_tile,
                title: t('map.tiles.orthographic')
            },
            {
                url: tileURLs.topographic,
                image: topographic_tile,
                title: t('map.tiles.topographic')
            },
            {
                url: tileURLs.base,
                image: base_tile,
                title: t('map.tiles.base')
            }, 
        ];
    }, [
        t
    ]);
    var togglePopup = (0,react.useCallback)(function() {
        return setPopupOpen(function(flag) {
            return !flag;
        });
    }, []);
    (0,react.useEffect)(function() {
        var control = new LeafletTileLayerControl({
            position: position
        });
        map.addControl(control);
        map.on('exitFullscreen', closePopup);
        return function() {
            map.removeControl(control);
            map.off('exitFullscreen', closePopup);
        };
    }, [
        map,
        position,
        closePopup
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TileLayer/* TileLayer */.I, {
                zIndex: 0,
                url: tileURL
            }, tileURL),
            /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "leaflet-bar",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "cursor-pointer",
                        onClick: togglePopup,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_map, {
                            width: 19,
                            height: 18
                        })
                    }),
                    popupOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                            className: "border border-gray-400",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row gap-4",
                                children: tileLayers.map(function(layer) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(BaseTileLayer, TileLayerControl_objectSpread({}, layer, {
                                        onClick: handleLayerChange,
                                        selected: layer.url === tileURL
                                    }), layer.title);
                                })
                            })
                        })
                    }) : null
                ]
            }), controlContainer)
        ]
    }));
};

// EXTERNAL MODULE: ../core/src/components/SvgIcon.tsx
var SvgIcon = __webpack_require__(16283);
;// CONCATENATED MODULE: ../assets/icons/no-boundary.svg
var no_boundary_path;

function no_boundary_extends() { no_boundary_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return no_boundary_extends.apply(this, arguments); }



var SvgNoBoundary = function SvgNoBoundary(props) {
  return /*#__PURE__*/react.createElement("svg", no_boundary_extends({
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), no_boundary_path || (no_boundary_path = /*#__PURE__*/react.createElement("path", {
    d: "M39.404 78.809c5.404 0 10.482-1.026 15.235-3.077a39.862 39.862 0 0 0 12.573-8.544 40.708 40.708 0 0 0 8.545-12.598c2.067-4.753 3.1-9.815 3.1-15.186 0-5.37-1.033-10.433-3.1-15.185a40.499 40.499 0 0 0-8.57-12.598A40.149 40.149 0 0 0 54.59 3.076C49.837 1.026 44.76 0 39.355 0c-5.37 0-10.432 1.025-15.185 3.076a39.572 39.572 0 0 0-12.549 8.545 40.916 40.916 0 0 0-8.52 12.598C1.034 28.97 0 34.033 0 39.404S1.034 49.837 3.1 54.59a40.706 40.706 0 0 0 8.546 12.597 39.862 39.862 0 0 0 12.573 8.545c4.752 2.051 9.814 3.077 15.185 3.077Zm0-7.422c-4.427 0-8.569-.822-12.426-2.466-3.858-1.644-7.243-3.93-10.157-6.86-2.913-2.93-5.192-6.332-6.836-10.206-1.644-3.873-2.465-8.024-2.465-12.45 0-4.428.813-8.578 2.441-12.452 1.628-3.874 3.898-7.275 6.812-10.205 2.913-2.93 6.298-5.216 10.156-6.86 3.857-1.644 8-2.466 12.427-2.466 4.46 0 8.618.822 12.475 2.466a31.999 31.999 0 0 1 10.18 6.86c2.93 2.93 5.225 6.331 6.886 10.205 1.66 3.874 2.49 8.024 2.49 12.451 0 4.427-.822 8.578-2.466 12.451-1.644 3.874-3.923 7.276-6.836 10.206-2.913 2.93-6.307 5.216-10.18 6.86-3.874 1.644-8.041 2.466-12.5 2.466Zm2.979-37.256c1.79-.619 3.263-1.71 4.419-3.272 1.155-1.562 1.733-3.353 1.733-5.37 0-2.507-.895-4.656-2.685-6.446s-3.94-2.686-6.446-2.686c-2.018 0-3.808.586-5.37 1.758-1.563 1.172-2.654 2.653-3.272 4.444l11.62 11.572ZM34.18 23.145c0-.782.285-1.457.854-2.027.57-.57 1.245-.854 2.027-.854.78 0 1.456.285 2.026.854.57.57.854 1.245.854 2.027 0 .748-.284 1.416-.854 2.002-.57.585-1.245.878-2.026.878-.782 0-1.457-.293-2.027-.878-.57-.586-.854-1.254-.854-2.002Zm2.197 20.41v7.959c0 2.018.114 3.914.342 5.688.228 1.774.561 3.223 1 4.346.44 1.123 1.002 1.684 1.685 1.684.651 0 1.197-.553 1.636-1.66.44-1.107.773-2.547 1.001-4.321.228-1.774.342-3.687.342-5.737v-2.002l-6.006-5.957ZM57.08 59.717c.358.358.806.537 1.343.537.537 0 .985-.18 1.343-.537a1.93 1.93 0 0 0 .537-1.343c0-.505-.18-.952-.537-1.343l-37.94-37.94c-.39-.39-.846-.585-1.367-.585-.52 0-.977.195-1.367.586-.358.358-.537.806-.537 1.343 0 .537.179.984.537 1.342l37.988 37.94Z",
    fill: "#999"
  })));
};

/* harmony default export */ var no_boundary = (SvgNoBoundary);
;// CONCATENATED MODULE: ../assets/icons/expand.svg
var expand_path;

function expand_extends() { expand_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return expand_extends.apply(this, arguments); }



var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/react.createElement("svg", expand_extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), expand_path || (expand_path = /*#__PURE__*/react.createElement("path", {
    d: "M.995 7.695a.948.948 0 0 0 .708-.28.975.975 0 0 0 .276-.713v-.311l-.216-3.327 2.254 2.393L6.8 8.27a.923.923 0 0 0 .696.287c.304 0 .558-.094.762-.281a.953.953 0 0 0 .305-.736c0-.144-.026-.28-.078-.407a1.002 1.002 0 0 0-.222-.335L5.468 4.009l-2.41-2.25 3.358.216h.3c.287 0 .53-.092.725-.276a.925.925 0 0 0 .294-.706.944.944 0 0 0-.294-.712A1.009 1.009 0 0 0 6.716 0H1.739C1.187 0 .759.152.456.455.152.758 0 1.185 0 1.735v4.967a.97.97 0 0 0 .995.993ZM11.285 18h4.976c.552 0 .98-.152 1.283-.455.304-.303.456-.73.456-1.28v-4.967a.969.969 0 0 0-.995-.993.964.964 0 0 0-.983.993v.311l.227 3.327-2.254-2.393L11.2 9.73a.923.923 0 0 0-.696-.287c-.304 0-.558.094-.761.281a.953.953 0 0 0-.306.736c0 .144.026.28.078.407.052.128.126.24.222.335l2.794 2.789 2.41 2.25-3.346-.216h-.312a1 1 0 0 0-.719.276.974.974 0 0 0-.3.706c0 .287.098.524.294.712.196.187.438.281.726.281Z",
    fill: "#014152"
  })));
};

/* harmony default export */ var expand = (SvgExpand);
;// CONCATENATED MODULE: ../assets/icons/shrink.svg
var shrink_path;

function shrink_extends() { shrink_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return shrink_extends.apply(this, arguments); }



var SvgShrink = function SvgShrink(props) {
  return /*#__PURE__*/react.createElement("svg", shrink_extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), shrink_path || (shrink_path = /*#__PURE__*/react.createElement("path", {
    d: "M1.818 8.196h4.898c.543 0 .964-.145 1.263-.436.299-.29.449-.7.449-1.228V1.779a.931.931 0 0 0-.278-.688.955.955 0 0 0-.702-.276.936.936 0 0 0-.968.964v.287l.212 3.203-2.219-2.307L1.735.275A.921.921 0 0 0 1.05 0C.751 0 .502.088.301.264a.886.886 0 0 0-.301.7c0 .138.026.268.077.39.05.123.124.234.218.333l2.75 2.664 2.373 2.158-3.293-.195h-.307c-.284 0-.522.086-.714.258a.858.858 0 0 0-.29.672c0 .275.097.503.29.683.192.18.43.27.714.27Zm8.722 9a.92.92 0 0 0 .685-.275.942.942 0 0 0 .271-.689v-.321l-.212-3.192 2.219 2.296 2.762 2.71a.92.92 0 0 0 .684.275c.3 0 .55-.088.75-.264.2-.176.301-.41.301-.7 0-.138-.026-.268-.077-.39a1.093 1.093 0 0 0-.218-.334l-2.762-2.686-2.373-2.158 3.294.207h.33c.283 0 .52-.088.708-.264a.884.884 0 0 0 .284-.678.884.884 0 0 0-.284-.677.999.999 0 0 0-.708-.264H11.26c-.543 0-.964.146-1.263.436-.299.291-.448.7-.448 1.229v4.775c0 .276.094.505.283.689a.975.975 0 0 0 .708.275Z",
    fill: "#014152"
  })));
};

/* harmony default export */ var shrink = (SvgShrink);
// EXTERNAL MODULE: ../../node_modules/leaflet/dist/leaflet.css
var leaflet = __webpack_require__(84198);
// EXTERNAL MODULE: ../../node_modules/leaflet.fullscreen/Control.FullScreen.css
var leaflet_fullscreen_Control_FullScreen = __webpack_require__(74870);
;// CONCATENATED MODULE: ../core/src/components/Maps/index.tsx

















function Maps_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Maps_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Maps_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Maps_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Maps_templateObject() {
    var data = Maps_taggedTemplateLiteral([
        "\n  && {\n    width: 100%;\n    height: 100%;\n    font-family: ",
        ";\n  }\n\n  a {\n    color: ",
        ";\n  }\n\n  .leaflet-top,\n  .leaflet-bottom {\n    z-index: 400;\n\n    &.leaflet-left {\n      bottom: 0;\n\n      .leaflet-control {\n        position: static;\n      }\n    }\n  }\n\n  && .leaflet-bar {\n    border-width: 1px;\n    border-color: ",
        ";\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06),\n      0px 0px 1px rgba(0, 0, 0, 0.04);\n\n    a {\n      width: 38px;\n      height: 38px;\n      border: none;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  .leaflet-popup-content-wrapper {\n    border-radius: 4px;\n  }\n\n  .leaflet-popup-content p {\n    margin: 0px;\n  }\n\n  .leaflet-marker-icon.cluster {\n    background-color: ",
        ";\n    border-radius: 20px;\n    background-clip: padding-box;\n  }\n\n  && .fullscreen-icon {\n    background-size: auto;\n    background-image: url(",
        ");\n    background-position: center;\n\n    &.leaflet-fullscreen-on {\n      background-image: url(",
        ");\n      background-position: center;\n    }\n  }\n"
    ]);
    Maps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Maps_templateObject1() {
    var data = Maps_taggedTemplateLiteral([
        "w-full h-full flex"
    ]);
    Maps_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Maps_taggedTemplateLiteral([
        "flex flex-1 justify-center items-center bg-gray-400"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var expandIconUrl = 'data:image/svg+xml,' + encodeURIComponent((0,server_browser.renderToStaticMarkup)(/*#__PURE__*/ (0,jsx_runtime.jsx)(expand, {
    width: 18,
    height: 18
})));
var shrinkIconUrl = 'data:image/svg+xml,' + encodeURIComponent((0,server_browser.renderToStaticMarkup)(/*#__PURE__*/ (0,jsx_runtime.jsx)(shrink, {
    width: 18,
    height: 18
})));
var FluidMap = (0,styled_components_browser_esm/* default */.ZP)(MapContainer/* MapContainer */.h).withConfig({
    componentId: "sc-5ff2e6cc-0"
})(Maps_templateObject(), theme_default().fontFamily.sans.join(', '), (theme_default()).colors.primary[500], (theme_default()).colors.gray[400], (theme_default()).colors.secondary[300], expandIconUrl, shrinkIconUrl);
var Container = dist_default().div(Maps_templateObject1());
var FallbackContainer = dist_default().div(_templateObject2());
var staticOptions = {
    doubleClickZoom: false,
    closePopupOnClick: false,
    dragging: false,
    zoomSnap: 0,
    zoomDelta: 0,
    trackResize: false,
    touchZoom: false,
    scrollWheelZoom: false
};
var Map = function(_param) {
    var children = _param.children, staticMap = _param.staticMap, fallback = _param.fallback, props = _objectWithoutProperties(_param, [
        "children",
        "staticMap",
        "fallback"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: fallback ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FallbackContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                src: no_boundary,
                size: 78
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(FluidMap, Maps_objectSpread({
            minZoom: 6,
            maxZoom: 18,
            attributionControl: false,
            zoomControl: false
        }, staticMap && staticOptions, props, {
            children: [
                staticMap ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TileLayer/* TileLayer */.I, {
                    url: tileURLs.orthographic
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TileLayerControl, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomControl, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenControl, {})
                    ]
                }),
                children
            ]
        }))
    }));
};
/* harmony default export */ var Maps = (Map);


/***/ })

}]);